/**
 * Guinean franc.
 */
export var GNF = {
  code: 'GNF',
  base: 10,
  exponent: 0
};